import styled from '@emotion/styled'
import { wrap as withStyle } from 'utils/styles'

export default withStyle(
  (props) => `
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  `
)

export const OverRunDescription = styled.span`
  background: red;
  color: white;
  padding: 0 1px;
`
